import React from 'react'
import styles from './Instruments.module.css'

function Instruments({ leftHead = 'left', rightHead = 'right', leftIcon, rightIcon, leftChilds, rightChilds, selfHead, change }) {
	const classLeftHead = selfHead == 'left' ? styles.active_left : ''
	const classRightHead = selfHead == 'right' ? styles.active_right : ''

	return (
		<div className={styles.InstrumentsWrrapper}>
			<div className={styles.MenuWrapper}>
				<h3 className={classLeftHead} onClick={change.bind(null, 'left')}>
					{leftIcon} {leftHead}{' '}
				</h3>
				<h3 className={classRightHead} onClick={change.bind(null, 'right')}>
					{rightIcon} {rightHead}{' '}
				</h3>
			</div>
			<div className={styles.instruments}>{selfHead == 'left' ? leftChilds : rightChilds}</div>
		</div>
	)
}

export default Instruments
